module.exports = __webpack_public_path__ + "img/IS540502-2930.9cc9d35f.png";